const React = require('react');
const helper = require('../../../helper/dish-helper');
const classnames = require('classnames');
const GroupDishDetail = require('./group-dish-detail/group-dish-detail.jsx');

import SingleDishDetail from './single-dish-detail.jsx';
import BaseComponent from '../../../helper/BaseComponent';

require('./dish-detail-container.scss');

class DishDetailContainer extends BaseComponent {
  static propTypes = {
    dish: React.PropTypes.object.isRequired,
    sameRuleDishList: React.PropTypes.array,
    onCloseBtnTap: React.PropTypes.func.isRequired,
    onAddToCarBtnTap: React.PropTypes.func.isRequired,
    singleMaximum: React.PropTypes.number,
    ifShowToolTip: React.PropTypes.bool,
    confirmButtonText: React.PropTypes.string,
    showMemberPriceInfo: React.PropTypes.bool,
  };

  static defaultProps = {
    showMemberPriceInfo: true,
  };

  constructor(props) {
    super(props);

    this.bind('onCloseBtnTap');
  }

  onCloseBtnTap(evt) {
    evt.preventDefault();

    if (location.hash === '#hot-dish') {
      this.props.onCloseBtnTap();
    } else {
      location.hash = '';
      this.props.onCloseBtnTap();
    }
  }

  render() {
    const {
      dish,
      sameRuleDishList,
      onAddToCarBtnTap,
      changeShowDataItems,
      singleMaximum,
      ifShowToolTip,
      confirmButtonText,
      showMemberPriceInfo,
    } = this.props;
    const isGroupDish = helper.isGroupDish(dish);

    return (
      <div
        className={classnames('dish-detail-container', {
          'single-dish-detail-all': !isGroupDish,
          'group-dish-detail-all': isGroupDish,
        })}
      >
        <div
          className={classnames('dish-detail-container_mask', {
            'dish-detail-container_mask__modify': isGroupDish,
          })}
          onTouchTap={this.onCloseBtnTap}
        />
        <div className="dish-detail-content">
          {isGroupDish ? (
            <GroupDishDetail
              dish={dish}
              showMemberPriceInfo={showMemberPriceInfo}
              changeShowDataItems={changeShowDataItems}
              onAddToCarBtnTap={onAddToCarBtnTap}
              onCloseBtnTap={this.onCloseBtnTap}
              confirmButtonText={confirmButtonText}
            />
          ) : (
            <SingleDishDetail
              changeShowDataItems={changeShowDataItems}
              dish={dish}
              showMemberPriceInfo={showMemberPriceInfo}
              sameRuleDishList={sameRuleDishList}
              onAddToCarBtnTap={onAddToCarBtnTap}
              onCloseBtnTap={this.onCloseBtnTap}
              maximum={singleMaximum}
              ifShowToolTip={ifShowToolTip}
              confirmButtonText={confirmButtonText}
            />
          )}
        </div>
      </div>
    );
  }
}

export default DishDetailContainer;



// WEBPACK FOOTER //
// ./src/component/dish-menu/detail/dish-detail-container.jsx